

/*****************************************
 * helpers
 *****************************************/

// from idx i1 and up to i2 (not including)
export function hexToDecimal(val, i1, i2) {
  return parseInt(val.slice(i1, i2), 16);
}


// 2 chars
export function decimalToHex(val) {
  let hex = Math.floor(val + .5).toString(16);
  hex = hex.slice(-2).padStart(2, '0');
  return hex;
}


export function clearData2D(size = { width: 2, height: 2 }) {

  const data2D = new Array(size.height);
  for (let i = 0; i < size.height; i++) {
    // all white
    data2D[i] = new Array(size.width).fill('ffffffff');
  }
  data2D.width = size.width;
  data2D.height = size.height;
  return data2D;
}


